import React, {Component} from 'react'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

class Label extends Component {

  render() {
    const {className, ...props} = this.props

    return <Font element="label" type="disclaimer" color="accent" weight="semiBold" className={[className, styles.label].join(' ')} {...props}/>
  }
}

export {Label}

export default Label
